import { ApolloError } from "@apollo/client";
import { useState } from "react";
import { ActivityLibraryModalProps } from "./types";
import { Modal } from "components/molecules/Modal";
import { ActivityDetailForm } from "../../../ActivityDetails/components/ActivityDetailForm";
import { EditViewToggle } from "../../../ActivityDetails/components/EditViewToggle";
import { Link } from "@mui/material";

export const ActivityDetailModal = (props: ActivityLibraryModalProps) => {
  const [editView, setEditView] = useState<boolean>(false);
  const [singleActivityError, setSingleActivityError] = useState<ApolloError>();

  const modalTitle = "Activity Detail";
  const detailsAddress = `/activity-details/${props.activityId}`;

  return (
    <>
      <Modal
        open={props.open}
        onClose={props.onClose}
        error={singleActivityError}
        title={modalTitle}
        modalClickable={
          <EditViewToggle editView={editView} setEditView={setEditView} />
        }
        editView={editView}
        width={30}
        rightSide
      >
        <Link
          href={detailsAddress}
          rel="noreferrer noopener"
          target="_blank"
          sx={{ width: "75%" }}
        >
          Open details in new tab
        </Link>
        <div style={{ maxWidth: "30rem" }}>
          <ActivityDetailForm
            setActivityFilterStatus={props.setActivityFilterStatus}
            allData={props.activityLibrary}
            activityId={props.activityId}
            isOpen={props.open}
            editView={editView}
            setEditView={setEditView}
            setSingleActivityError={setSingleActivityError}
          />
        </div>
      </Modal>
    </>
  );
};
